import { Box } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
export const DashedWrapper = ({ children }) => {
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            alignItems: 'center',
            justifyContent: { xs: 'center', lg: 'unset' },
            width: '100%',
            border: 'dashed',
            borderRadius: 2,
            borderColor: themeColors.border.main,
            backgroundColor: themeColors.surface.primary,
        }, "data-test": 'empty-content-wrapper' }, children));
};
